import axiosInstance from "./axiosInstance";
const getAllHashTag = async ({pageParam = 1}) => {
  const accessToken = localStorage.getItem("accessTokenGC");
  try {
    const {data} = await axiosInstance.get(
      `/api/getAllHashTag?page=${pageParam}&limit=5`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return {
      hashTags: data.hashTags,
      nextPage: pageParam + 1,
      totalPages: data.pagination.totalPages,
    };
  } catch (error) {
    throw new Error("Error fetching hash tags.");
  }
};

export default getAllHashTag;
